// target=_blank のリンクを全てselfにする（ECタブで開くとクラッシュするため暫定対応）
(function () {
  function isMobile() {
    let userAgent = window.navigator.userAgent.toLowerCase();
    let regexp = /android|webos|iphone|ipad|ipod|blackberry|mobile|iemobile|opera mini/i;
    return (userAgent.search(regexp) != -1);
  }

  if (isMobile()) {
    const links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_self';
        links[i].rel = '';
      }
    }
  }
})();
